export { default as OutfitDetail } from './outfitDetail'
export { default as OutfitsListing } from './outfitsListing'



// WEBPACK FOOTER //
// ./src/templates/outfits/index.js